export default (function (metadata) {
  if (metadata === void 0) {
    metadata = {};
  }
  if (Object.entries(metadata).length === 0) {
    return metadata;
  }
  const {
    dataLayer = {}
  } = metadata;
  let eventName = '';
  let pagetype = '';
  let activeTab = '';
  switch (dataLayer.page?.pg) {
    case 'fyc_vdp':
      eventName = 'Buy - Viewed VDP';
      pagetype = 'offerdetail';
      activeTab = 'summary';
      break;
    default:
  }
  return {
    eventName,
    data: {
      dynx_itemid: dataLayer.vehicle?.vin,
      dynx_pagetype: pagetype,
      from: dataLayer.page?.pageName,
      activeTab,
      csListingId: dataLayer.vehicle?.id,
      sslp: dataLayer.vehicle?.pricingDetail?.salePrice,
      // used to determine 'most popular' years/makes/models
      numPhotos: dataLayer.vehicle?.images?.sources?.length,
      mileage: dataLayer.vehicle?.mileage?.value,
      price: dataLayer.vehicle?.pricingDetail?.salePrice,
      year: dataLayer.vehicle?.year,
      make: dataLayer.vehicle?.make,
      model: dataLayer.vehicle?.model,
      content_ids: dataLayer.vehicle?.id,
      vin: dataLayer.vehicle?.vin,
      transmission: dataLayer.vehicle?.transmission?.description || dataLayer.vehicle?.transmission?.name,
      drivetrain: dataLayer.vehicle?.driveType?.description || dataLayer.vehicle?.driveType?.name,
      body_style: (dataLayer.vehicle?.bodyStyleCodes || []).join(' '),
      fuel_type: dataLayer.vehicle?.fuelTypeGroup,
      exterior_color: dataLayer.vehicle?.color?.exteriorColor,
      postal_code: dataLayer.vehicle?.owner?.location?.address?.zip,
      country: 'United States',
      state_of_vehicle: dataLayer.vehicle?.owner?.location?.address?.state,
      dealer_id: dataLayer.vehicle?.owner?.id,
      cs_listing_id: dataLayer.vehicle?.id,
      is_psx: true
    }
  };
});